import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.src
    ? _c(
        "article",
        {
          staticClass: "banner-item rounded-20",
          attrs: { "data-qa": "banner_item" },
        },
        [
          _c(VImg, {
            staticClass: "rounded-20",
            attrs: {
              "data-qa": "banner_item_image",
              src: _vm.src,
              "aspect-ratio": _setup.isMobile ? 350 / 240 : 1148 / 320,
              contain: "",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }